// @ts-nocheck
/**
 * @module StickyNav
 * @description
 */
import React, { FC, useContext, useEffect, useState } from 'react';
import { CartContext } from 'ui/providers/cart';
import Link from 'next/link';
import { handleClick } from '../SiteNavigation/helpers';
import { stringify } from 'ui/js/utils/filters';
import ComplementaryMenu from '../SiteNavigation/menus/ComplementaryMenu';
import { complementaryMenuLinks } from '../SiteNavigation/links';
import { FeatureFlagContext } from 'ui/providers/feature-flagging';
import Component from 'ui/components/Component';
import Icon from 'ui/components/Icon';
import styles from './index.module.css';

interface Props {

}

const StickyNav: FC<Props> = () => {
  const { clickThrough } = useContext( CartContext );
  const [ isVisible, setIsVisible] = useState( false );
  const { cartHeavy, phoneHeavy } = useContext( FeatureFlagContext );

  useEffect( () => {
    setTimeout( () => {
      setIsVisible( true ); /* this fixes hydration warning */
    }, 1 );
  }, [ ] );

  return (
    <Component
      className={ styles.component }
      data-cart-heavy={ cartHeavy }
      data-phone-heavy={ phoneHeavy }
    >
      <>
        { isVisible &&
          <div className={ styles.container }>
            <div className={ styles.body }>
              <ComplementaryMenu
                className={ styles.stickyNavMenu }
                links={ [] }
              />

              <div className={ styles.cart }>
                <Link
                  href={ clickThrough }
                  onClick={ handleClick }
                  className={ styles.phoneBtn }
                  data-payload={ stringify( {
                    text: 'Buy',
                    actionOutcome: 'INTERNALLINK'
                  } ) }
                >
                  Buy
                </Link>
              </div>

              <div className={ styles.phone } suppressHydrationWarning={ true }>
                <Link
                  href="tel:18668893199"
                  onClick={ handleClick }
                  suppressHydrationWarning={ true }
                  data-payload={ stringify( {
                    text: 'Phone Number',
                    actionOutcome: 'CLICKTOCALL'
                  } ) }
                >
                  <span>Call now</span> <Icon className={ styles.icon } icon="phone-outline"/> <em>1-866-889-3199</em>
                </Link>
            </div>
            </div>
          </div>
        }
      </>
    </Component>
  );
};

StickyNav.displayName = 'StickyNav';

export default StickyNav;
